import React from "react";
import { DailyStyle, Hero, Main } from "../components";


function Home() {
  return (
    <section>
      <Hero />
      <Main />
      <DailyStyle />
    </section>
  );
}



export default Home;
